import { Unit } from '@/types/util/eth-unit';
import { utils } from 'web3';
const ETHER = 'ether';

export const ethToWei = (aAmount: string): string => {
  return utils.toWei(aAmount, ETHER);
};

export const weiToEth = (aAmount: string): string => {
  return utils.fromWei(aAmount, ETHER);
};

export const converterToEth = (aAmount: string, aUnit: Unit, aFromUnit: Unit = ETHER): string => {
  const amountInWei = utils.toWei(aAmount, aUnit);
  if (amountInWei === '0') {
    return '0';
  }
  const amountInEther = utils.fromWei(amountInWei, aFromUnit);
  return amountInEther;
};

export const EthToConverter = (aAmount: string, aUnit: Unit): string => {
  const weiAmount = utils.toWei(aAmount, ETHER);

  const szaboAmount = utils.fromWei(weiAmount, aUnit);
  return szaboAmount;
};
